var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 2.72665H21.6364C22.2055 2.72665 22.6668 2.26535 22.6668 1.69633C22.6668 1.12732 22.2055 0.666016 21.6364 0.666016H1.03032C0.461303 0.666016 0 1.12732 0 1.69633C0 2.26535 0.461303 2.72665 1.03032 2.72665Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03129 4.78711C0.462279 4.78711 0.000976562 5.24841 0.000976562 5.81743C0.000976562 6.38644 0.462279 6.84774 1.03129 6.84774H16.1424C16.7114 6.84774 17.1727 6.38644 17.1727 5.81743C17.1727 5.24841 16.7114 4.78711 16.1424 4.78711H1.03129Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 10.9688H21.6364C22.2054 10.9688 22.6667 10.5075 22.6667 9.93852C22.6667 9.36951 22.2054 8.9082 21.6364 8.9082H1.03032C0.461303 8.9082 0 9.36951 0 9.93852C0 10.5075 0.461303 10.9688 1.03032 10.9688Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03032 19.211H21.6364C22.2055 19.211 22.6668 18.7497 22.6668 18.1807C22.6668 17.6117 22.2055 17.1504 21.6364 17.1504H1.03032C0.461303 17.1504 0 17.6117 0 18.1807C0 18.7497 0.461303 19.211 1.03032 19.211Z",
    fill: "#232323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03129 13.0293C0.462279 13.0293 0.000976562 13.4906 0.000976562 14.0596C0.000976562 14.6286 0.462279 15.0899 1.03129 15.0899H16.1424C16.7114 15.0899 17.1727 14.6286 17.1727 14.0596C17.1727 13.4906 16.7114 13.0293 16.1424 13.0293H1.03129Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlignIcon);
export default __webpack_public_path__ + "static/media/left_align_icon.d1d2d8b9d5ee74d1bb19308d73c0e2a9.svg";
export { ForwardRef as ReactComponent };